import React, { useState } from "react";
import { collection, addDoc } from "firebase/firestore";
import { firestore } from "../firebaseConfig";
import { useNavigate } from "react-router-dom";
import ConceptSelectorModal from "./ConceptSelectorModal";
import MaterialListModal from "./MaterialListModal";
import GeriButonu from "../components/GeriButonu";
import PerdeTagModal from "../components/PerdeTagModal";
import { useAlert } from "../context/AlertContext";

function AddReservation() {
  const navigate = useNavigate();
  const { showSuccess, showError } = useAlert();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMaterialModalOpen, setIsMaterialModalOpen] = useState(false);
  const [isPerdeModalOpen, setIsPerdeModalOpen] = useState(false);

  const [customerName, setCustomerName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [selectedConcept, setSelectedConcept] = useState("");
  const [rentedItems, setRentedItems] = useState([]);
  const [notes, setNotes] = useState("");
  const [location, setLocation] = useState("");
  const [perdeTag, setPerdeTag] = useState(false);
  const [tempItems, setTempItems] = useState([]);
  const [tempConceptName, setTempConceptName] = useState("");

  const handleOpenConceptModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const handleSelectConceptWithItems = (conceptName, items = []) => {
    setTempConceptName(conceptName);
    setTempItems(items);
    setIsModalOpen(false);
    setIsMaterialModalOpen(true);
  };

  const handleItemsConfirmed = (finalItems) => {
    setSelectedConcept(tempConceptName);
    setRentedItems(finalItems);
    setIsMaterialModalOpen(false);
    setTimeout(() => setIsPerdeModalOpen(true), 200);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newReservation = {
      customerName,
      phoneNumber,
      eventDate,
      selectedConcept,
      rentedItems: rentedItems.filter((item) => item.checked),
      notes,
      address: location,
      perdeTag,
    };

    try {
      await addDoc(collection(firestore, "reservations"), newReservation);
      showSuccess("Rezervasyon kaydedildi 🎉", "", { emoji: "📅" });

      setCustomerName("");
      setPhoneNumber("");
      setEventDate("");
      setSelectedConcept("");
      setRentedItems([]);
      setNotes("");
      setLocation("");
      setPerdeTag(false);

      setTimeout(() => navigate("/"), 1500);
    } catch (error) {
      console.error("Hata oluştu:", error);
      showError("Kayıt başarısız", "Lütfen tekrar deneyin.", {
        emoji: "❌",
      });
    }
  };

  return (
    <div className="reservation-wrapper">
      <GeriButonu />

      <style>{`
        .reservation-wrapper {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
          align-items: center;
          background-color: #f9fafb;
          padding: 2rem 1rem;
        }

        .form-box {
          background: white;
          padding: 2rem;
          border-radius: 12px;
          box-shadow: 0 4px 16px rgba(0,0,0,0.1);
          max-width: 400px;
          width: 100%;
          text-align: center;
          font-family: 'Segoe UI', sans-serif;
        }

        .form-title {
          font-size: 1.5rem;
          font-weight: bold;
          margin-bottom: 1.5rem;
          color: #374151;
        }

        .form-input {
          width: 100%;
          padding: 0.75rem;
          margin-bottom: 1rem;
          border: 1px solid #ccc;
          border-radius: 6px;
          font-size: 1rem;
          color: #111 !important;
          background-color: #fff !important;
          -webkit-text-fill-color: #111 !important;
        }

        input[type="date"] {
          color: #111 !important;
          background-color: #fff !important;
          -webkit-text-fill-color: #111 !important;
        }

        .form-button {
          width: 100%;
          padding: 0.75rem;
          background-color: #6366f1;
          color: white;
          font-size: 1rem;
          font-weight: 600;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          margin-top: 0.5rem;
        }

        .form-button:hover {
          background-color: #4f46e5;
        }

        .selected-concept {
          margin: 1rem 0;
          font-size: 1rem;
          color: #374151;
        }
      `}</style>

      <div className="form-box">
        <h2 className="form-title">Rezervasyon Oluştur</h2>

        <input
          type="text"
          placeholder="Müşteri Adı"
          value={customerName}
          onChange={(e) => setCustomerName(e.target.value)}
          className="form-input"
        />
        <input
          type="text"
          placeholder="Telefon Numarası"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          className="form-input"
        />
        <input
          type="date"
          value={eventDate}
          onChange={(e) => setEventDate(e.target.value)}
          className="form-input"
        />
        <input
          type="text"
          placeholder="Konum (Salon adı, adres vs.)"
          value={location}
          onChange={(e) => setLocation(e.target.value)}
          className="form-input"
        />
        <textarea
          placeholder="Notlar (isteğe bağlı)"
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          className="form-input"
          rows={3}
        />

        <button onClick={handleOpenConceptModal} className="form-button">
          Konsept Seç
        </button>

        <p className="selected-concept">
          Seçilen Konsept: <strong>{selectedConcept || "Henüz seçilmedi"}</strong>
        </p>

        <button onClick={handleSubmit} className="form-button">
          Kaydet
        </button>
      </div>

      <ConceptSelectorModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onSelectConceptWithItems={handleSelectConceptWithItems}
      />

      <MaterialListModal
        isOpen={isMaterialModalOpen}
        defaultItems={tempItems}
        onConfirm={handleItemsConfirmed}
        onClose={() => setIsMaterialModalOpen(false)}
      />

      <PerdeTagModal
        isOpen={isPerdeModalOpen}
        onClose={() => setIsPerdeModalOpen(false)}
        onSelect={(value) => {
          setPerdeTag(value);
          setIsPerdeModalOpen(false);
        }}
      />
    </div>
  );
}

export default AddReservation;
